import { render, staticRenderFns } from "./intent-utterance.vue?vue&type=template&id=3a72ce0e&scoped=true"
import script from "./intent-utterance.ts?vue&type=script&lang=ts&external"
export * from "./intent-utterance.ts?vue&type=script&lang=ts&external"
import style0 from "./intent-utterance.less?vue&type=style&index=0&id=3a72ce0e&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72ce0e",
  null
  
)

export default component.exports